import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import './Style.css';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Navbar,
  Row
} from 'react-bootstrap';
import Benfit from './Benfit';
import Footer from './Footer';
import TestStyle from './TestStyle';
import StepsPage from './StepsPage';
import { Testbg } from './Testbg';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { useAppContext } from 'providers/AppProvider';
import logo from 'assets/img/brand/pro.png';
import './style.css';

interface HomepageProps {
  logo?: string;
  className?: string;
}

const Homepage = ({
  className,
  children
}: PropsWithChildren<HomepageProps>) => {
  const {
    config: { isNavbarVerticalCollapsed }
  } = useAppContext();
  const { breakpoints } = useBreakpoints();
  return (
    <>
      <Navbar expand="lg" className="custom-navbar bg-opacity-75 text-white ">
        <Container fluid>
          <div className="d-flex align-items-center">
            {breakpoints.up('xs') &&
            breakpoints.down('sm') &&
            breakpoints.down('lg') &&
            breakpoints.down('md') ? null : (
              <img
                src={logo}
                alt="phoenix"
                width={80}
                style={{
                  width: '80px',
                  height: 'auto',
                  zIndex: 999,
                  position: 'relative'
                }}
              />
            )}

            {!isNavbarVerticalCollapsed && (
              <Navbar.Brand href="#" className=" ms-2 text-white fs-6">
                Propertiesbyphone
              </Navbar.Brand>
            )}
          </div>

          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Form className="d-flex align-items-center gap-3 ms-auto">
              <Button
                type="submit"
                className="btn btn-primary"
                as={Link}
                to="/sign-up"
              >
                Sign up
              </Button>
              <Button
                type="submit"
                className="btn btn-primary"
                as={Link}
                to="/sign-in"
              >
                Sign in
              </Button>
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container
        fluid
        className=" opacity-75 min-vh-100 py-12 d-flex align-items-center justify-content-center "
        style={{
          boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
          borderRadius: '10px'
        }}
      >
        <div
          className="bg-holder bg-auth-card-overlay position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage: `url(${'https://yellowstonevalleywoman.com/images/img_UFcVLcawBPn7Lrh2igSRWT/dspb7426.jpg?fit=outside&w=1600&dpr=1'})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: '-1'
          }}
        />

        <Row className="flex-center position-relative g-0 px-3 py-5 w-100" sty>
          <Col xs={12} sm={10} md={8} lg={6} xl={5} className="text-center">
            <h1 className=" text-white responsive-heading">
              Unleash The Power <br /> Of Your Yard Signs !
            </h1>

            <div>
              <p className="text-white mt-2 mb-4 responsive-p">
                Get The 2 Minute, DONE FOR YOU Yard Sign Lead Generation System.
              </p>
            </div>

            <div className="Video-section mt-4 p-3  d-inline-block w-100">
              <div className="ratio ratio-16x9">
                <iframe
                  src="https://www.youtube.com/embed/YcXpNqo68A4"
                  width="1333"
                  height="750"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="rounded"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <Benfit />
      <StepsPage />

      <TestStyle />
      {/* <Testbg /> */}

      <Footer />
    </>
  );
};

export default Homepage;
